import React from 'react';
import { CloseOutlined } from '@mui/icons-material';
import ProfileHero     from '../../molecules/ProfileHero/ProfileHero';
import ProfileKpis     from '../../molecules/ProfileKpis/ProfileKpis';
import ProfileTabs     from '../../molecules/ProfileTabs/ProfileTabs';
import ActivityFeed    from '../../molecules/ActivityFeed/ActivityFeed';
import ProfileEditForm from '../../molecules/ProfileEditForm/ProfileEditForm';
import PasswordForm    from '../../molecules/PasswordForm/PasswordForm';
import './ProfilePanel.css';

const TABS = [
  { key: 'activity', label: 'Activité' },
  { key: 'edit',     label: 'Modifier profil' },
  { key: 'password', label: 'Mot de passe' },
];

const ProfilePanel = ({
  profile, stats, recent, loading, saving,
  tab, onTabChange,
  formData, initialData, onProfileChange, onSaveProfile,
  onSavePassword, pwdError,
  onClose,
}) => {
  if (loading) return (
    <div className="pp-overlay" onClick={onClose}>
      <div className="pp-panel" onClick={(e) => e.stopPropagation()}>
        <div className="pp-loading"><div className="pp-spinner" /></div>
      </div>
    </div>
  );

  return (
    <div className="pp-overlay" onClick={onClose}>
      <div className="pp-panel" onClick={(e) => e.stopPropagation()}>

        <button className="pp-close" onClick={onClose}>
          <CloseOutlined />
        </button>

        <ProfileHero profile={profile} />
        <ProfileKpis stats={stats} />
        <ProfileTabs tabs={TABS} active={tab} onChange={onTabChange} />

        <div className="pp-body">
          {tab === 'activity' && (
            <ActivityFeed stats={stats} recent={recent} />
          )}
          {tab === 'edit' && (
            <ProfileEditForm
              formData={formData}
              initialData={initialData}
              onChange={onProfileChange}
              onSave={onSaveProfile}
              saving={saving}
            />
          )}
          {tab === 'password' && (
            <PasswordForm
              onSave={onSavePassword}
              saving={saving}
              error={pwdError}
            />
          )}
        </div>

      </div>
    </div>
  );
};

export default ProfilePanel;